import React, { useState } from 'react'
import Content from 'blocks.app/content/content'
import Uploader from 'blocks.app/uploader'
import translate from 'core/translate'
import { isHorizontalMenu } from 'core/helpers/menu'
import { cn } from 'ethcss'
import { grid } from 'theme'
import { checkAvailableModule } from '../../../core/helpers/routes/routes'
import { InstancesCatalogDaysAndClasses } from './InstancesCatalogDaysAndClasses'
import { InstancesCatalogSchedule } from './InstancesCatalogSchedule'
import styles from './styles.jcss'
import {
    SCHOOL_SCHEDULE_MODULE_KEY,
    SCHOOL_SCHEDULE_TABS,
    SCHOOL_SCHEDULE_TITLE_KEY,
    SCHOOL_SCHEDULE_UPLOAD_METHOD,
    SchoolScheduleFilterItem,
    SchoolScheduleFilterParameter,
    SchoolScheduleFilterState,
    SchoolScheduleTab,
} from './InstancesCatalogSchoolSchedule-types'

const INITIAL_FILTER_STATE: SchoolScheduleFilterState = {
    selectedClassNumber: '1',
    selectedClassLetter: 'а',
    day: 1,
}

const InstancesCatalogSchoolScheduleComponent = () => {
    const [activeTab, setActiveTab] = useState<SchoolScheduleTab>('schoolSchedule')
    const [filterState, setFilterState] = useState<SchoolScheduleFilterState>(INITIAL_FILTER_STATE)

    const onDataChange = (parameter: SchoolScheduleFilterParameter, value: string | number) => {
        setFilterState((prevState) => ({
            ...prevState,
            [parameter]: value,
        }))
    }

    const customFilterList = (list: SchoolScheduleFilterItem[]) => {
        return list.filter(
            (element) =>
                element.classNumber === filterState.selectedClassNumber &&
                element.classLetter.toLowerCase() === filterState.selectedClassLetter.toLowerCase() &&
                element.day === filterState.day
        )
    }

    const renderActiveTab = () => {
        switch (activeTab) {
            case 'schoolSchedule':
                return (
                    <>
                        <InstancesCatalogDaysAndClasses
                            selectedClassNumber={filterState.selectedClassNumber}
                            selectedClassLetter={filterState.selectedClassLetter}
                            day={filterState.day}
                            onDataChange={onDataChange}
                        />
                        <InstancesCatalogSchedule customFilterList={customFilterList} />
                    </>
                )
            case 'downloadFromFile':
                return (
                    <div className={cn(grid.w100, grid.flex, grid.center)}>
                        <Uploader uploadMethod={SCHOOL_SCHEDULE_UPLOAD_METHOD} isModal={false} />
                    </div>
                )
            default:
                return null
        }
    }

    return (
        <Content title={SCHOOL_SCHEDULE_TITLE_KEY}>
            <div className={cn(styles.tabsWrapper, isHorizontalMenu() && styles.tabsWrapper_x)}>
                {SCHOOL_SCHEDULE_TABS.map((tab) => (
                    <div
                        key={tab}
                        className={cn(styles.tabBtn, activeTab === tab && styles.tabActive)}
                        onClick={() => setActiveTab(tab)}
                    >
                        {translate(tab)}
                    </div>
                ))}
            </div>
            {renderActiveTab()}
        </Content>
    )
}

export const InstancesCatalogSchoolSchedule = checkAvailableModule(SCHOOL_SCHEDULE_MODULE_KEY)
    ? InstancesCatalogSchoolScheduleComponent
    : null
